// file imports
import { formatDate } from '@/lib/helpers';
import { IPresentation } from '@/types';
import Link from 'next/link';
import { FeedbackQRCode } from '@/components';

interface PresentationDetailFieldProps {
  label: string;
  value: string | number | null | undefined;
  spanFull?: boolean;
}

function PresentationDetailField({ label, value, spanFull = false }: PresentationDetailFieldProps) {
  const displayValue = value || <span className="text-gray-400">N/A</span>;
  const spanClass = spanFull ? 'md:col-span-2' : '';

  return (
    <div className={spanClass}>
      <span className="font-semibold block text-gray-700 text-sm sm:text-base">{label}:</span>
      <span className="text-gray-900 text-sm sm:text-base">{displayValue}</span>
    </div>
  );
}

export default function PresentationDetailsSection({ event }: { event: IPresentation }) {
  return (
    <>
      <div className="bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 shadow flex flex-col gap-4 sm:gap-6 w-full md:w-3/4 mx-auto mb-4">
        {/* Header with edit button */}
        <div className="flex items-center justify-between">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">Presentation Details</h2>
          <Link href={`/presentations/${event.slug}/edit`} className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            <span className="text-xs sm:text-sm font-medium">Edit</span>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-y-4 gap-x-2 md:gap-x-8">
          <PresentationDetailField label="Title" value={event.title} />
          <PresentationDetailField label="Date" value={formatDate(event.date.toString())} />
          <PresentationDetailField label="Organization" value={event.organization} />
          <PresentationDetailField label="Presentation Type" value={event.presentationType} />
          <PresentationDetailField label="Category" value={event.category} />
          <PresentationDetailField label="Rate" value={event.rate} />
          <PresentationDetailField label="Presentation ID" value={event.slug} spanFull />
        </div>
      </div>
      <FeedbackQRCode eventSlug={event.slug || ''} title="Presentation QR Code" />
    </>
  );
}
